import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Buildpurpose(props) {
  return (
    <div className="services_orange_bg p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center order-2 order-md-1"
          >
            <StaticImage
              src="../../images/services/managed-clouds/drive_growth.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={651}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="services_title my-auto order-1 order-md-2"
          >
            <h2>Drive Your Business Growth With Our Cloud Solutions</h2>
            <p>
              We focus on enhancing your cloud experience by managing your cloud
              efficiently, creating numerous opportunities for your business to
              make your in-house processes more agile.
            </p>
            <p>
              With well-planned strategies, we bolster your business's bottom
              line and empower innovation within your cloud environment.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Buildpurpose;
